import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { DlpSummary } from "../../components/dlp/DlpSummary";
import { InsuredPersonDetails } from "../../components/Shared/personalDetails/InsuredPersonDetails";
import { Step } from "../../components/stepIndicator/Step";
import { StepIndicator } from "../../components/stepIndicator/StepIndicator";
import { scrollToFirstValidationMessage } from "../../components/validationMessage/scrollToFirstValidationMessage";
import { ValidationMessage } from "../../components/validationMessage/ValidationMessage";
import { useDidMount } from "../../hooks/useDidMount";
import { useDlpFlowContext } from "../../hooks/useDlpContext";
import { FlowLayout } from "../FlowLayout";

interface Props {
  fields: Record<string, Field<string>>;
}

export const DlpFlowStepThree = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { data, goToStepFour, goBack, currentStep, modelState, setModelState, setters } = useDlpFlowContext();

  useDidMount(() => {
    if (currentStep !== 3) {
      goBack(1, props.fields.Step2Path.value);
    }
  });

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, props.fields.Step1Path.value);
    }

    if (index === 1) {
      goBack(2, props.fields.Step2Path.value);
    }
  };

  const goToStep1 = () => {
    goBack(1, props.fields.Step1Path.value);
  };

  const goToStep4 = async () => {
    try {
      setLoading(true);
      await goToStepFour(props.fields.Step4Path.value);
    } catch {
      setLoading(false);
      scrollToFirstValidationMessage();
    }
  };

  if (currentStep !== 3) {
    return null;
  }

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={2}>
        <Step label={props.fields.step1Name.value} labelMobile={props.fields.step1MobileName.value} />
        <Step label={props.fields.step2Name.value} labelMobile={props.fields.step2MobileName.value} />
        <Step label={props.fields.step3Name.value} labelMobile={props.fields.step3MobileName.value} />
        <Step label={props.fields.step4Name.value} labelMobile={props.fields.step4MobileName.value} />
        <Step label={props.fields.step5Name.value} labelMobile={props.fields.step5MobileName.value} />
      </StepIndicator>
      <FlowLayout
        Sidebar={
          <DlpSummary
            {...props}
            submitButtonProps={{
              id: "button_submit_personal_details",
              children: props.fields.PersonalDetailsSubmitButtonText.value,
              loading,
              onClick: goToStep4,
            }}
          />
        }
        {...props}
      >
        <>
          <ValidationMessage id="global" modelState={modelState} property="Global" />

          {data.insuredPersons.map((insuredPerson, index) => (
            <InsuredPersonDetails
              key={insuredPerson.personId}
              index={index}
              fields={props.fields}
              data={insuredPerson}
              setModelState={setModelState}
              onUpdateInsured={setters.updateInsuredData}
              handleEditDateOfBirth={goToStep1}
              modelState={modelState}
              hideAddressAndContactDetails={false}
              isSecondInsured={index > 0}
            />
          ))}
        </>
      </FlowLayout>
    </>
  );
};
